import { Link } from "react-router-dom";
import { heroSpecForViewport } from "./heroSlideImageSpecs";

export function HeroSlideUploadHint({ viewport }) {
	const spec = heroSpecForViewport(viewport);
	return (
		<p className="mt-2 font-Vazir-400 text-[12px] leading-relaxed text-darkBlue/55">
			<span className="font-Vazir-600 text-darkBlue/70">{spec.title}:</span>{" "}
			پیشنهاد {spec.recommended} (حداقل {spec.minimum}) — {spec.ratio}.{" "}
			<Link
				to="/dashboard/image-guidelines/"
				className="text-cta underline-offset-2 hover:underline"
			>
				راهنمای کامل عکس‌ها
			</Link>
		</p>
	);
}
